import React, { useEffect, useState } from 'react';
import fetchIntercept from 'fetch-intercept';
import { Guid as guid } from 'guid-typescript';
import { useSelector } from 'react-redux';
import { IStore } from './store';
import Footer from './components/common/footer/Footer';
import { getCurrentSessionId } from './services/session.service';
import { X_TENANT_ID } from './app.constant';
import ErrorBoundary from './components/common/errorBoundary/ErrorBoundary';
import PolicyStepper from './components/common/policy/PolicyStepper';
import UnAuthorizedAccess from './components/unAuthorizedAccess/UnAuthorizedAccess';
import { useNavigate } from 'react-router-dom';
import { DigitalData } from './utils/adobeAnalytics/models/digitalDataModel';
import { digitaldata } from './utils/adobeAnalytics/config';
import { executeAnalytics, getLastUri } from './utils/adobeAnalytics/adobeAnalyticsHelperFn';
import RoutingManager from './components/common/routeManager/RoutingManager';


declare global { 
  interface Window { 
    digitaldata: DigitalData; 
  } 
} 

if (!window.digitaldata) { 
  window.digitaldata = digitaldata; 
} 
let userId: string;
function App(): JSX.Element {
  const showPrivacyAndTermsModal = useSelector(
    (store: IStore) => store.common.showPrivacyAndTermsModal
  );


  const showUnauthorizedAccess = useSelector(
    (store: IStore) => store.common.showUnauthorizedAccess
  );

  useEffect(() => {
    let prevPageLastUri = getLastUri(window.location.href);
    executeAnalytics({ page: { pageName: prevPageLastUri } });
    const timer = setInterval(() => {
      const lastUri = getLastUri(window.location.href);
      if (lastUri != prevPageLastUri) {
        executeAnalytics({ page: { pageName: lastUri } });
        prevPageLastUri = lastUri;
      }
    }, 500);
    return () => clearInterval(timer);
  }, []);

  const sessionId = getCurrentSessionId();

  fetchIntercept.register({
    request: function (url: any, config: { headers: any }) {
      if (!config.headers) {
        config.headers = {};
      }
      config!.headers['Request-Id'] = guid.create();
      config!.headers['X-Correlation-Id'] = guid.create();
      config!.headers['X-Window-Id'] = sessionId;
      config!.headers['X-Tenant-Id'] = X_TENANT_ID;
      config!.headers['session-id'] = sessionId;
      return [url, config];
    },

    requestError: function (error: any) {
      return Promise.reject(error);
    },

    response: function (response: any) {
      return response;
    },

    responseError: function (error: any) {
      return Promise.reject(error);
    }
  });

  return (
    <div className='App'>
      <>
        {!showPrivacyAndTermsModal && (
         showUnauthorizedAccess ? (
            <UnAuthorizedAccess />
          ) : (
            <ErrorBoundary>
              <RoutingManager />
            </ErrorBoundary>
          )
        )}
        {showPrivacyAndTermsModal && (
          <div className="page-layout se-container">
            <PolicyStepper />
          </div>
        )}
      </>
       <Footer />
    </div>
  );

}

export default App;
